// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__Q5UcF","summary":"CartItem_summary__1INPr","price":"CartItem_price__2P_w2","amount":"CartItem_amount__1Zoud","actions":"CartItem_actions__3ysHZ"};